<div class="row">
  <div class="request__content col-12"
    *ngIf="!gettingLicenses && licenses.length === 0 && gettingLicensesError === 'DEFAULT_VALUE'">
    <p class="txt txt--paragraph mb-5">Aún no tiene licencias eliminadas.</p>
  </div>
  <div class="loader-licenses" *ngIf="gettingLicenses">
    <app-loader style="margin-top: 20px !important;"></app-loader>
  </div>
  <div class="request__content col-12">
    <div class="border-b" style="margin-bottom:10px !important;" *ngFor="let item of licenses;index as i">
      <app-license-card *ngIf="!gettingLicenses && licenses.length > 0 && gettingLicensesError === 'DEFAULT_VALUE'"
        [licensesData]="item" [zonesRows]="zonesRows" [userData]="selectedPersonData"></app-license-card>
      <button type="button" class="btn btn--primary mb-3" (click)="onSelectLicense(item.id)">Ver detalles y
        documentos</button>
    </div>
  </div>
</div>
